<app-multiselect-dropdown *ngIf="inventoryLocations$ | async as locations"
    class="filter"
    [formControl]="control" 
    [label]="label"
    [id]="'locations'"
    [placeholder]="'All Locations'"
    [data]="locations"
    [settings]="config"
    [itemsLimit]="selectedItemsBadgeLimitCount"
    [allocateContainerAutoDimensions]="locations.length < 4"
    (filterChanged)="markForCheck()"
    (dropDownOpened)="markForCheck()"
    (dropDownClosed)="markForCheck()"
    (selected)="markForCheck()"
    (deSelected)="markForCheck()"

></app-multiselect-dropdown>
